const graphApi = async () => {
  // Display loading message
  document.getElementById("result").innerText = "Loading...";
  console.log(document.cookie);
  try {
    const response = await fetch("https://apidev.hku.hk/graph/me", {
      method: "GET",
      headers: {
        "Accept": "application/json"
      },
      credentials: "include"
    });

    if (response.status === 401) {
      document.getElementById("result").innerText = "Unauthorized access. Please log in.";
      return;
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log(data);
    document.getElementById("result").innerText = JSON.stringify(data, null, 2);
    return data;
  } catch (error) {
    if (error.message.startsWith("HTTP error! Status: 401")) {
      // Handle the 401 error specifically without logging it to the console
      document.getElementById("result").innerText = "Unauthorized access. Please log in.";
    } else {
      document.getElementById("result").innerText = "An error occurred.";
      console.error("Error:", error);
    }
  }
};

const userContactInfo = async () => {
  try {
    const userInfo = await graphApi();
    const userName = userInfo.displayName;
    const guidUrl = `https://apidev.hku.hk/graph/dataverse-query-user-specific?tableName=contacts&userName=${userName}`;
    const guidResponse = await fetch(guidUrl, {
      credentials: "include",
      method: "GET",
    });
    if (guidResponse.ok) {
      const guidResult = await guidResponse.json();
      console.log("guidResult: ", guidResult);
      return guidResult;
    } else {
      console.log("Dataverse query of guid failed.");
    }
  } catch {
    // console.log(error.message);
  }
};

const userGuid = async () => {
  const contactInfo = await userContactInfo();
  console.log("contactInfo: ", contactInfo);
  
  // Check if contactInfo.value exists and has at least one element
  if (contactInfo.value && contactInfo.value.length > 0) {
    console.log("contactid: ", contactInfo.value[0].contactid);
    return contactInfo.value[0].contactid;
  } else {
    throw new Error('No contact information found');
  }
}

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

async function getFetchXml(tableName) {
  const guid = await userGuid();
  console.log("guid: ", guid);
  // fetchXml is stored in environment variables with the table name
  const fetchXml = process.env[`VUE_APP_FETCHXML_${tableName.toUpperCase()}`];
  console.log("fetchXml: ", fetchXml);
  if (fetchXml === undefined) {
    console.log("FetchXml is not defined.");
    return;
  }

  // replace the placeholder with the user's guid
  const replacedFetchXml = fetchXml.replace("{{guid}}", guid)
                                   .replace("{{currentDate}}", formatDate(new Date()));
  console.log("replacedFetchXml: ", replacedFetchXml);
  return replacedFetchXml;
}

async function queryDataverseFetchXml(tableName) {
  // validate tableName using environmental variables 
  const allowedTablesFetchXml = process.env.VUE_APP_ALLOWED_TABLES_FETCHXML.split(";");
  if (!allowedTablesFetchXml.includes(tableName)) {
    console.log("Table name is not allowed.");
    return;
  }

  // fetchXml is stored in environment variables with the table name
  const userInfo = await graphApi();
  const userName = userInfo.displayName;
  
  console.log("tableName: ", tableName);
  const fetchXml = await getFetchXml(tableName);
  console.log("fetchXml: ", fetchXml);
  const fetchXmlEncoded = encodeURIComponent(fetchXml);
  console.log("fetchXmlEncoded: ", fetchXmlEncoded);
  const url = `https://apidev.hku.hk/graph/dataverse-query-fetchxml?tableName=${tableName}&userName=${userName}&fetchXml=${fetchXmlEncoded}`;
  
  try {
    const response = await fetch(url, {
      credentials: "include",
      method: "GET",
    });

    if (response.ok) {
      const result = await response.json();
      console.log(result);
      return result;
    } else {
      console.log("Dataverse query failed.");
    }
  } catch {
    // console.log(error.message);
  }
}


async function queryDataverseUserSpecific(tableName) {
  // validate tableName using environmental variables 
  const allowedTablesUserSpecific = process.env.VUE_APP_ALLOWED_TABLES_USER_SPECIFIC.split(";");
  if (!allowedTablesUserSpecific.includes(tableName)) {
    console.log("Table name is not allowed.");
    return;
  }

  const userInfo = await graphApi();
  const userName = userInfo.displayName;
  const url = `https://apidev.hku.hk/graph/dataverse-query-user-specific?tableName=${tableName}&userName=${userName}`;

  try {
    const response = await fetch(url, {
      credentials: "include",
      method: "GET",
    });

    if (response.ok) {
      const result = await response.json();
      console.log(result);
      return result;
    } else {
      console.log("Dataverse query failed.");
    }
  } catch {
    // console.log(error.message);
  }
}

async function queryDataverseGeneral(tableName) {
  // validate tableName using environmental variables
  const allowedTablesGeneral = process.env.VUE_APP_ALLOWED_TABLES_GENERAL.split(";");
  if (!allowedTablesGeneral.includes(tableName)) {
    console.log("Table name is not allowed.");
    return;
  }

  const url = `https://apidev.hku.hk/graph/dataverse-query-general?tableName=${tableName}`;

  try {
    const response = await fetch(url, {
      credentials: "include",
      method: "GET",
    });

    if (response.ok) {
      const result = await response.json();
      console.log(result);
      return result;
    } else {
      console.log("Dataverse query failed.");
    }
  } catch {
    // console.log(error.message);
  }
}

async function postDataverse(tableName, data) {
  // validate tableName using environmental variables
  const allowedTablesPost = process.env.VUE_APP_ALLOWED_TABLES_POST.split(";");
  if (!allowedTablesPost.includes(tableName)) {
    console.log("Table name is not allowed.");
    return;
  }

  const userInfo = await graphApi();
  const userName = userInfo.displayName;
  const url = `https://apidev.hku.hk/graph/dataverse-post?tableName=${tableName}&userName=${userName}`;
  console.log("url: ", url);
  console.log("data: ", data);

  try {
    const response = await fetch(url, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (response.ok) {
      const result = await response.json();
      console.log(result);
      return result;
    } else {
      console.log("Dataverse post failed.");
    }
  } catch {
    // console.log(error.message);
  }
}

async function deleteDataverse(tableName, id) {
  // validate tableName using environmental variables
  const allowedTablesDelete = process.env.VUE_APP_ALLOWED_TABLES_DELETE.split(";");
  if (!allowedTablesDelete.includes(tableName)) {
    console.log("Table name is not allowed.");
    return;
  }

  const userInfo = await graphApi();
  const userName = userInfo.displayName;
  const url = `https://apidev.hku.hk/graph/dataverse-delete?tableName=${tableName}&userName=${userName}&id=${id}`;
  console.log("url: ", url);

  try {
    const response = await fetch(url, {
      credentials: "include",
      method: "DELETE"
    });

    if (response.ok) {
      const result = await response.json();
      console.log(result);
      return result;
    } else {
      console.log("Dataverse delete failed.");
    }
  } catch {
    // console.log(error.message);
  }
}

async function patchDataverse(tableName, id, data) {
  // validate tableName using environmental variables
  const allowedTablesPatch = process.env.VUE_APP_ALLOWED_TABLES_PATCH.split(";");
  if (!allowedTablesPatch.includes(tableName)) {
    console.log("Table name is not allowed.");
    return;
  }

  const userInfo = await graphApi();
  const userName = userInfo.displayName;
  const url = `https://apidev.hku.hk/graph/dataverse-patch?tableName=${tableName}&userName=${userName}&id=${id}`;
  console.log("url: ", url);
  console.log("data: ", data);

  try {
    const response = await fetch(url, {
      credentials: "include",
      method: "PATCH",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (response.ok) {
      const result = await response.json();
      console.log(result);
      return result;
    } else {
      console.log("Dataverse patch failed.");
    }
  } catch {
    // console.log(error.message);
  }
}

// Exports the functions to be used in the HTML
export { graphApi, queryDataverseFetchXml, queryDataverseUserSpecific, queryDataverseGeneral, postDataverse, deleteDataverse, patchDataverse, userGuid };